import {fetch} from "@/utils/fetch";

export function getServiceTask(formData) {
  return fetch({
    url: `${ process.env.VUE_APP_BASE_URL }/get-service-task-list`,
    method: 'post',
    data: formData
  })
}

// export function addServiceTask({ orderId, expeditingId, handleTime }) {
//   return fetch({
//     url: `${ process.env.VUE_APP_BASE_URL }/add-service-task`,
//     method: 'post',
//     params: {
//       orderId,
//       expeditingId,
//     }
//   })
// }

export function addServiceTask({ orderId, expeditingId, handleTime }) {
  return fetch({
    url: `${ process.env.VUE_APP_BASE_URL }/reminder`,
    method: 'get',
    params: {
      orderId
    }
  })
}

export function changeStatus(id, result) {
  return fetch({
    url: `${ process.env.VUE_APP_BASE_URL }/change-status`,
    method: 'post',
    data: {
      id: id,
      dealResult: result
    }
  })
}
